import {
  ComponentRef,
  createComponent,
  Directive,
  ElementRef,
  EnvironmentInjector,
  HostListener,
  Inject,
} from '@angular/core';
import { InlineComponentEditorComponent } from '../inline-component-editor/inline-component-editor.component';
import { EditorService } from '../../services/editor.service';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appEditableComponent]',
  standalone: true
})
export class EditableComponentDirective {
  private cmpRef?: ComponentRef<InlineComponentEditorComponent>;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private host: ElementRef<HTMLElement>,
    private envInjector: EnvironmentInjector,
    private editorService: EditorService,
    @Inject(DOCUMENT) private doc: Document
  ) {}

  @HostListener('mouseenter')
  onEnter() {
    if (!this.editorService.isEditModeEnabled()) return;
    this.clearHideTimer();
    this.showToolbar();
  }

  @HostListener('mouseleave', ['$event'])
  onLeave(ev: MouseEvent) {
    if (
      !this.editorService.isEditModeEnabled() ||
      this.editorService.isBlock(ev)
    )
      return;
    this.startHideTimer();
  }

  private attachToolbarListeners(el: HTMLElement) {
    if ((el as any).__hasToolbarListeners) return;
    el.addEventListener('pointerenter', () => this.clearHideTimer());
    el.addEventListener('pointerleave', () => this.startHideTimer());
    (el as any).__hasToolbarListeners = true;
  }

  private startHideTimer() {
    if (this.hideTimer) return;
    this.hideTimer = setTimeout(() => {
      this.destroyToolbar();
      this.hideTimer = null;
    }, 50);
  }

  private clearHideTimer() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  private showToolbar(): void {
    const pos = this.host.nativeElement.getBoundingClientRect();
    const originalEl: HTMLElement = this.host.nativeElement;
    if (this.cmpRef) {
      setTimeout(() => {
        this.positionToolbar(this.cmpRef!.location.nativeElement, pos);
      });
      this.attachToolbarListeners(this.cmpRef.location.nativeElement);
      this.cmpRef.instance.target = this.host.nativeElement;
      return;
    }

    this.cmpRef = createComponent(InlineComponentEditorComponent, {
      environmentInjector: this.envInjector,
    });

    const el = this.cmpRef.location.nativeElement as HTMLElement;
    this.cmpRef.setInput?.('value', originalEl);
    el.setAttribute('data-editor-toolbar', '');

    setTimeout(() => {
      this.positionToolbar(el, pos);
    });

    this.attachToolbarListeners(el);
    this.cmpRef.instance.target = this.host.nativeElement;
    this.cmpRef.instance.closed.subscribe(() => this.destroyToolbar());

    this.doc.body.appendChild(el);
  }

  private handleMove(el: HTMLElement, dir: string) {
    console.log('Przesunięto blok', el, 'kierunek', dir);
  }

  private positionToolbar(el: HTMLElement, pos: DOMRect): void {
    // Wyśrodkuj w poziomie
    el.style.position = 'absolute';
    el.style.left = `${pos.left + pos.width / 2 - 100 + window.scrollX}px`;
    el.style.top = `${
      pos.top + pos.height / 2 - el.offsetHeight / 2 - 100 + window.scrollY
    }px`;
    el.style.zIndex = '2000';
  }

  private destroyToolbar(): void {
    if (!this.cmpRef) return;
    const el = this.cmpRef.location.nativeElement as HTMLElement;
    this.cmpRef.destroy();
    el.remove();
    this.cmpRef = undefined;
  }
}
